import _ from "lodash";
import React from "react";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import { connect } from "react-redux";
import { Field, reduxForm, reset, submit } from "redux-form";
import { NEW_IMAGE_PATH, BASE_IMAGES_URL } from "Constants";
import { updateUnsavedChanges } from "DashboardMenuAction";
import BrandingInlineCropper from "./brandinginnercropper";
import { ColorExtractor } from "react-color-extractor";
import {
  updateWebThemeColors,
  updateWebIconLocally,
  updateWebCoverLocally,
} from "BrandingAction";
import LocaleStrings from "Languages";

class WebBrandingImages extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      accept: "image/png",
      files: [],
      imageEventIcon: "",
      imageEventCover: "",
      eventIconAvailableLocally: false,
      eventCoverAvailableLocally: false,
      eventIconAvailableOnDrop: false,
      eventCoverAvailableOnDrop: false,
      eventIconReset: false,
      eventCoverReset: false,
    };

    this.onDropCover = this.onDropCover.bind(this);
    this.onDrop = this.onDrop.bind(this);

    this.colorsCallback = this.colorsCallback.bind(this);

    this.iconCropperRef = React.createRef();
    this.coverCropperRef = React.createRef();
  }

  eventIconAvailableOnDrop = (available) => {
    if (available !== undefined)
      this.setState({ eventIconAvailableOnDrop: available });
  };

  onEventIconAvailable = (available) => {
    if (available !== undefined)
      this.setState({
        eventIconAvailableLocally: available,
        eventIconAvailableOnDrop: available,
      });
  };

  saveIconImage = (callback) => {
    //We need to call the callback only if image wasn't saved manually just dropped.
    if (
      this.state.eventIconAvailableOnDrop &&
      !this.state.eventIconAvailableLocally
    ) {
      this.iconCropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  onEventCoverAvailable = (available) => {
    if (available !== undefined)
      this.setState({
        eventCoverAvailableLocally: available,
        eventCoverAvailableOnDrop: available,
      });
  };

  eventCoverAvailableOnDrop = (available) => {
    if (available !== undefined)
      this.setState({ eventCoverAvailableOnDrop: available });
  };

  saveCoverImage = (callback) => {
    //We need to call the callback only if image wasn't saved manually just dropped.
    if (
      this.state.eventCoverAvailableOnDrop &&
      !this.state.eventCoverAvailableLocally
    ) {
      this.coverCropperRef.current.saveImage(callback);
    } else {
      callback();
    }
  };

  onDrop(files) {
    // debugger;
    this.props.updateUnsavedChanges(true);

    this.setState({ imageEventIcon: files, eventIconReset: true });
    this.props.change("webicon", files);
    this.props.updateWebIconLocally(files);
  }

  onDropCover(files) {
    this.props.updateUnsavedChanges(true);

    this.setState({ imageEventCover: files, eventCoverReset: true });

    this.props.change("webcover", files);
    this.props.updateWebCoverLocally(files);
  }

  colorsCallback(colors) {
    // debugger;
    if (colors && colors.length > 0) {
      var colorsData = [];
      colors.map((color, id) => {
        colorsData.push({ color: color, custom: false, selected: false });
      });

      var custom = _.find(this.props.colors, ["custom", true]);

      colorsData.push(custom);

      var colorSelected = _.find(this.props.colors, ["selected", true]);

      if (colorSelected && !colorSelected.custom) {
        colorsData = [colorSelected, ...colorsData];
      }

      this.props.updateWebThemeColors(colorsData);
    }
  }

  applyMimeTypes(event) {
    this.setState({
      accept: event.target.value,
    });
  }

  submitBrandingData() {
    //debugger;
    this.saveIconImage(() => {
      this.saveCoverImage(() => {
        this.props.dispatch(submit("Web-Branding-Form"));
      });
    });
    //this.props.dispatch(submit('Branding-Form'));
    //this.props.handleSubmit();
  }

  render() {
    var { handleSubmit, pristine, submitting, invalid, submit } = this.props;

    var {
      accept,
      eventIconAvailableOnDrop,
      eventCoverAvailableOnDrop,
      eventCoverReset,
      eventIconReset,
    } = this.state;

    var eventIconStyle = "row appicon-warp";
    var eventCoverStyle = "row appicon-warp";

    var { webicon, webcover } = this.props.brandingData;
    var eventIconPreviewUrl = "";
    var eventCoverPreviewUrl = "";

    if (webicon && !eventIconReset) {
      eventIconPreviewUrl = `${BASE_IMAGES_URL}/${webicon}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      eventIconAvailableOnDrop = true;
    }

    if (webcover && !eventCoverReset) {
      eventCoverPreviewUrl = `${BASE_IMAGES_URL}/${webcover}?api_key=${this.props.session.apiKey}&session_token=${this.props.session.sessionToken}`;
      eventCoverAvailableOnDrop = true;
    }

    return (
      <form onSubmit={handleSubmit(submit)} encType="multipart/form-data">
        <div className="BrandingForm">
          <div className="form-group formdiv">
            <label className="control-label-top container col-sm-12">
              {LocaleStrings.branding_event_icon}
              <img
                src="../../style/images/header-icons/infoicon.png"
                style={{ paddingLeft: 10, marginTop: -2, cursor: "pointer" }}
              ></img>
              <div className="overlay">
                <div
                  className="text bigtext-fortab"
                  style={{ marginLeft: 235 }}
                >
                  The icon should be in png format. Minimum 256px wide by 256px
                  tall
                </div>
              </div>
            </label>
            <div className="col-sm-12 col-sm-offset-0 imgPreview">
              <section>
                <BrandingInlineCropper
                  imgwidth={256}
                  imgheight={256}
                  width={150}
                  height={150}
                  border={2}
                  onImageSave={this.onDrop}
                  imagepath={eventIconPreviewUrl}
                  onImageAvailableLocally={this.onEventIconAvailable}
                  onImageDropped={this.eventIconAvailableOnDrop}
                  imageType="png"
                  className="websmalldropbox"
                  innerText={
                    <div className="drop-text">
                      <div>
                        <img src={`${NEW_IMAGE_PATH}picture.png`} />
                      </div>
                      <div>
                        {LocaleStrings.drag_and_drop} <br />
                        {LocaleStrings.or}{" "}
                        <span className="select-file">
                          {LocaleStrings.select_file}
                        </span>
                      </div>
                    </div>
                  }
                  ref={this.iconCropperRef}
                />
                <Field name="webicon" component="input" type="hidden" />
              </section>
              {eventIconAvailableOnDrop ? (
                <div style={{ height: 20 }}>
                  {this.state.imageEventIcon ? (
                    <ColorExtractor
                      src={this.state.imageEventIcon}
                      getColors={this.colorsCallback}
                    />
                  ) : null}
                </div>
              ) : (
                <div className={eventIconStyle}>
                  <div
                    className="col-md-12"
                    style={{ padding: 0, paddingTop: 10 }}
                  >
                    <p className="text-select">
                      {" "}
                      - {LocaleStrings.branding_upload_icon_notes1}{" "}
                    </p>
                    <p className="text-select2">
                      {" "}
                      - {LocaleStrings.branding_upload_icon_notes2}{" "}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="form-group formdiv">
            <label
              className="control-label-top container col-sm-12"
              style={{ marginTop: "40px" }}
            >
              {LocaleStrings.branding_event_cover}
              <img
                src="../../style/images/header-icons/infoicon.png"
                style={{ paddingLeft: 10, marginTop: -2, cursor: "pointer" }}
              ></img>
              <div className="overlay">
                <div
                  className="text brandlogo-textab"
                  style={{ marginLeft: 245 }}
                >
                  The icon should be in png format. Minimum 1920px wide by
                  1080px tall
                </div>
              </div>
            </label>
            <div className="col-sm-12 col-sm-offset-0 imgPreview">
              <section>
                <BrandingInlineCropper
                  imgwidth={1400}
                  imgheight={560}
                  width={560}
                  height={250}
                  border={2}
                  onImageSave={this.onDropCover}
                  onImageAvailableLocally={this.onEventCoverAvailable}
                  onImageDropped={this.eventCoverAvailableOnDrop}
                  imagepath={eventCoverPreviewUrl}
                  imageType="png"
                  className="bigdropbox"
                  innerText={
                    <div className="drop-text-extended">
                      <div>
                        <img src={`${NEW_IMAGE_PATH}picture.png`} />
                      </div>
                      <div>
                        {LocaleStrings.drag_and_drop} <br />
                        {LocaleStrings.or}{" "}
                        <span className="select-file">
                          {LocaleStrings.select_file}
                        </span>
                      </div>
                    </div>
                  }
                  ref={this.coverCropperRef}
                />
                <Field name="webcover" component="input" type="hidden" />
              </section>
              {eventCoverAvailableOnDrop ? (
                <div style={{ height: 20 }}>&nbsp;</div>
              ) : (
                <div className={eventCoverStyle}>
                  <div
                    className="col-md-12"
                    style={{ padding: 0, paddingTop: 10 }}
                  >
                    <p className="text-select">
                      {" "}
                      - {LocaleStrings.branding_upload_icon_notes3}{" "}
                    </p>
                    <p className="text-select2">
                      {" "}
                      - {LocaleStrings.branding_upload_icon_notes4}{" "}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

function mapStateToProps(state) {
  //   var activeWebColor={};
  //   if(state.brandingWebColor){
  //     activeWebColor=state.brandingWebColor.color;
  //   }
  return {
    session: state.session,
    brandingData: state.brandingData,
    colors: state.webthemeColors,
    activeWebColor:
      Object.keys(state.brandingWebColor).length == 1
        ? state.brandingWebColor.color
        : state.brandingWebColor,
  };
}

function onFormSubmit(values, dispatch, props) {
  values = { ...values, webthemecolor: props.activeWebColor.color };
  props.submitBrandingDataHandler(values);
}

export default connect(
  mapStateToProps,
  {
    updateUnsavedChanges,
    updateWebThemeColors,
    updateWebIconLocally,
    updateWebCoverLocally,
  },
  null,
  { forwardRef: true }
)(
  reduxForm({
    form: "Web-Branding-Form",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    onSubmit: onFormSubmit,
  })(WebBrandingImages)
);
